import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Chart::HoverOverlay\n  @height={{@height}}\n  @width={{@width}}\n  @getIdentifierForX={{this.getIdentifierForX}}\n  @updateTooltip={{this.updateTooltip}}\n/>")